import Vue from "vue";
import App from "./App.vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./element-variables.scss";
//Note: 请注意：把下面代码放在tailwindcss/tailwind.css文件里面，代码位置一定要放在@tailwind base; 这行代码下方，
//因为这个会影响生成PDF证书文件里面文字显示位置
//@layer base {
//     img {
//         @apply inline-block;
//     }
// }
import "tailwindcss/tailwind.css";
import "normalize.css";
import "./assets/common/form-mobile.css";
import router from "./router";
import UserData from "./utils/UserData";
import dayjs from "dayjs";
import locale from "element-ui/lib/locale/lang/en";
import ElInputTag from "el-input-tag";
import pdf from "./utils/pdf";
import { loadTestUserIds } from "./utils/store";

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)
Vue.use(pdf);
Vue.prototype.$dayjs = dayjs;
Vue.prototype.$UserData = UserData;
Vue.config.productionTip = false;

Vue.prototype.$globalMessage = new Vue();

Vue.use(ElementUI, { locale });
Vue.use(ElInputTag);

// Fallback if index.html recovery did not run (e.g. cached shell without the script).
// Prefer hash assignment over location.replace — full replace can loop in WeChat/WebViews.
(function recoverPublicDeepLink() {
    try {
        function getParam(name) {
            let s = window.location.search || ''
            if (s.charAt(0) === '?') s = s.slice(1)
            if (!s) return ''
            const parts = s.split('&')
            for (let i = 0; i < parts.length; i++) {
                const kv = parts[i].split('=')
                const key = decodeURIComponent(kv[0] || '')
                if (key === name) {
                    return decodeURIComponent((kv[1] || '').replace(/\+/g, ' '))
                }
            }
            return ''
        }
        const page = getParam('eae_page')
        if (!page) return
        const expected = '#/' + String(page).replace(/^\//, '')
        if (window.location.hash && window.location.hash.indexOf(expected) === 0) return
        const id = getParam('id')
        const advisorId = getParam('advisor_id')
        let hash = expected
        const q = []
        if (id) q.push('id=' + encodeURIComponent(id))
        if (advisorId) q.push('advisor_id=' + encodeURIComponent(advisorId))
        if (q.length) hash += '?' + q.join('&')
        window.location.hash = hash
    } catch (e) {}
})()

function mountApp() {
    new Vue({
        router,
        render: (h) => h(App),
    }).$mount("#app");
}

// Prefetch RETestUser ids so isTestUser() can stay sync for pay / QA gates.
loadTestUserIds().finally(mountApp);
